import { useEffect, useState } from "react";
import Claims from "./components/claims";
import Features from "./components/features";
import ProductCarousel from "./components/productCarosal";
import ProductDatas from "./components/productDetails";
import VariantsPanel from "./components/variantsPanel";
import api from "../../shared/utils/request";
import { useParams } from "react-router-dom";
import PageLoader from "../shared/pageLoader";
import { buildProductSeo, useSeo } from "../../shared/seo";
import ProductInfo from "./components/productInfo";

const ProductDetails = () => {
  const { slug } = useParams();

  const [productDetails, setProductDetails] = useState([]);
  const [activeVariant, setActiveVariant] = useState(null);
  const [loading, setLoading] = useState(true);
  const seoData = buildProductSeo(productDetails, activeVariant);

  useSeo(seoData);

  useEffect(() => {
    const getProductDetails = async () => {
      setLoading(true);
      try {
        const data = await api.get(`customer/get-product-by-id/${slug}`);
        setProductDetails(data?.productDatas);
        setActiveVariant(data?.productDatas?.product_variants[0]);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Failed to fetch product details:", error);
      }
    };

    getProductDetails();
  }, [slug]);

  return (
    <>
      {loading && <PageLoader />}
      <section className="product-details py-40">
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-lg-1 d-none d-lg-block"></div>
            <div className="col-12 col-lg-5 order-1 order-lg-1">
              <ProductCarousel activeVariant={activeVariant} />
              <ProductDatas
                activeVariant={activeVariant}
                productDetails={productDetails}
                setActiveVariant={setActiveVariant}
              />
              <div className="d-none d-lg-block">
                <ProductInfo />
              </div>
            </div>
            <div className="col-12 col-lg-5 order-3 order-lg-2">
              <VariantsPanel
                productDetails={productDetails}
                activeVariant={activeVariant}
                setActiveVariant={setActiveVariant}
              />
              <div className="mt-24">
                <Features />
              </div>
            </div>
            <div className="col-12 order-4 d-lg-none">
              <ProductInfo />
            </div>
            <div className="col-lg-1 d-none d-lg-block"></div>
          </div>
        </div>
      </section>
      <Claims />
    </>
  );
};
export default ProductDetails;
